import React, { memo } from 'react';
import block from 'bem-cn';
import isEqual from 'lodash.isequal';

import { PragmaticDGAMegaWheel } from 'components/slots/PragmaticDGA/hooks';

import './MegaWheel.scss';

const b = block('pragmatic-dga-mega-wheel');

type MegaWheelProps = {
  results: PragmaticDGAMegaWheel['last20Results']
};

export const MegaWheel = memo(({ results }: MegaWheelProps) => (
  <div className={b()}>
    {results.map(({ result, slot, multiplier }, index) => (
      <div key={index} className={b('result', { type: result })}>
        {result === slot && <div className={b('multiplier')}>x{multiplier}</div>}
        <span className={b('result-value')}>{result}</span>
      </div>
    ))}
  </div>
), isEqual);
